module.exports = __webpack_public_path__ + "static/media/fairy_2.0b2cde72.jpg";